import { useGetFeatureFlags } from "./integrations/feature-flags/query";

export const FeatureFlagEnum = {
	NEW_STORAGE_PAGE: "NEW_STORAGE_PAGE",
	NEW_INVENTORY_PAGE: "NEW_INVENTORY_PAGE",
	NEW_FINANCIAL_ACCOUNT_LAUNCH: "NEW_FINANCIAL_ACCOUNT_LAUNCH",
	EMPLOYEE_EMAIL_REGISTRATION: "EMPLOYEE_EMAIL_REGISTRATION",
	BANK_ACCOUNT_V2_PAGE: "BANK_ACCOUNT_V2_PAGE",
	WIZARD_LOW_TOUCH: "WIZARD_LOW_TOUCH",
	NEW_CMV_REPORT: "NEW_CMV_REPORT",
} as const;

type FeatureFlag = typeof FeatureFlagEnum[keyof typeof FeatureFlagEnum];

export function useHasFeatureFlagEnabled(
	featureFlag: FeatureFlag,
	placeId?: string | null,
): [isEnabled: boolean, isLoading: boolean] {
	const { data: featureFlags, isLoading } = useGetFeatureFlags({
		placeId: placeId ?? null,
	});

	const isEnabled = !!featureFlags?.some(ff => ff.key === featureFlag && ff.enabled);

	return [isEnabled, isLoading];
}
